import { TicketGiftCard } from '../models/serializable/discounts/ticket-gift-card.js';
import { GiftCardDiscountProvider } from './gift-card-discount-provider.js';

export class TicketGiftCardDiscountProvider extends GiftCardDiscountProvider {
  constructor(giftCard: TicketGiftCard) {
    super(giftCard);
  }
}
